<div class="h-screen w-full flex flex-col lg:flex-row relative overflow-hidden">
  <!-- Sidebar toggle mobile -->
  @if (sidebar.isMobile() && sidebar.collapsed()) {
    <button
      type="button"
      (click)="sidebar.toggleSidebar()"
      class="fixed top-4 inset-s-4 z-50 bg-linear-to-br from-blue-500 to-blue-900 text-white py-1 px-2 rounded-2xl shadow-xl"
    >
      <i class="bi bi-list text-2xl font-bold"></i>
    </button>
  }

  <app-sidebar #sidebar />

  <!-- CONTENEDOR PRINCIPAL -->
  <div class="flex flex-col flex-1 min-w-0 min-h-0 overflow-hidden">
    <!-- HEADER FIJO -->
    <app-panel-header />

    <!-- MAIN -->
    <main
      class="flex-1 min-h-0 overflow-hidden"
      (click)="sidebar.isMobile() && !sidebar.collapsed() ? sidebar.toggleSidebar(false) : null"
    >
      <!-- 🔥 AQUÍ VA EL SCROLL REAL -->
      <div class="h-full min-h-0 p-2 overflow-y-auto">
        <router-outlet />
      </div>
    </main>
  </div>
</div>
